import { useEffect, useRef } from "react";

import { useOnboardingContextOptional } from "@/common/contexts/onboarding";
import { RoutingHelper } from "@/common/helpers/routing";
import { useAuthenticationInfo } from "@/common/hooks/auth/useAuthenticationInfo";
import { useAuthorizationInfo } from "@/common/hooks/auth/useAuthorizationInfo";
import { useAuthorizationProfile } from "@/common/hooks/auth/useAuthorizationProfile";
import { useCurrentTenantInfoV2 } from "@/common/hooks/entity/tenant/useCurrentTenantInfoV2";
import { UserStatus } from "@/core/api/generated/v1";

/** Ensures onboarding is seed at least once and started. If not, redirects to onboarding page. */
export function OnboardingAppGuard() {
  // NB: ensure authorized API endpoints aren't called if user is not authenticated to avoid redirects to login on 401
  const authenticationInfo = useAuthenticationInfo();
  const authorizationInfo = useAuthorizationInfo();
  const { authorizationProfile } = useAuthorizationProfile();
  const tenantInfo = useCurrentTenantInfoV2();
  const onboardingContext = useOnboardingContextOptional();

  const isRedirectingRef = useRef(false);

  useEffect(() => {
    if (
      !isRedirectingRef.current &&
      authenticationInfo.isAuthenticated &&
      authorizationInfo.isPermissionsReady &&
      authorizationProfile?.status === UserStatus.Active &&
      RoutingHelper.isFleetAreaActive() &&
      tenantInfo.isTenantContext &&
      onboardingContext?.forceRedirectOnLaunchOnce()
    ) {
      isRedirectingRef.current = true;
      return;
    }
  }, [authenticationInfo, authorizationInfo, authorizationProfile, tenantInfo, onboardingContext]);

  return null;
}
